module.exports = __webpack_public_path__ + "static/media/partner4.7f87c6db.jpg";